import * as React from 'react';
import { Safari } from 'app/app.quotion.co/[isEU]/(dashboard)/site/[subdomain]/(shrinked-sidebar)/design/_components/preview/safari';
import { faviconAtom } from 'app/blog/[domain]/_components/design-state';
import { BackgroundBeams } from 'components/bg-beams/bg-beams';
import { IconWrapper } from 'components/icon-wrapper';
import { IconMail01 } from 'icon/Communication/mail-01';
import { useAtom } from 'jotai';
import { BlurFade, Button, FocusableLink, Input } from 'ui';

export function NewsletterFeature() {
  const [_, setFavicon] = useAtom(faviconAtom);
  React.useEffect(() => {
    setFavicon('https://quotion.co/favicon.ico');
  }, [setFavicon]);

  return (
    <div className="flex w-full flex-col items-start text-start">
      <BlurFade delay={0.2}>
        <IconWrapper className="mb-6">
          <IconMail01 />
        </IconWrapper>
      </BlurFade>
      <BlurFade delay={0.1}>
        <h2 className="mb-4 text-display-sm font-semibold">
          Newsletter built-in
        </h2>
      </BlurFade>
      <BlurFade delay={0.2}>
        <p className="mb-6 max-w-5xl text-lg text-gray-600">
          Transform Apple Notes into engaging newsletters. Our dashboard makes
          it simple to manage and send updates directly to your audience with
          unlimited subscribers and unlimited newsletters.
        </p>
      </BlurFade>
      <BlurFade delay={0.25} yOffset={6} className="w-full">
        <Safari
          id="newsletter"
          openUrl="https://quotion.co/blog"
          urlBar="quotoin.co/blog"
          tab="all"
          className="max-w-full"
        >
          <section className="mx-auto max-w-5xl px-4 py-20">
            <div className="relative flex flex-col items-center gap-4 rounded-2xl border px-4 py-16 shadow-xs">
              <div className="z-1 pb-8">
                <h2 className="bg-linear-to-b from-[rgb(var(--text-primary))] to-[rgb(var(--border-primary))] bg-clip-text pb-5 text-center text-display-sm font-bold text-transparent sm:text-display-md">
                  Subscribe to Quotion
                </h2>
                <p className="max-w-3xl text-balance text-center text-lg text-tertiary sm:text-xl">
                  Get the latest posts delivered to your inbox. No spam,
                  unsubscribe anytime.
                </p>
              </div>
              <div className="z-1">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                  }}
                  className="flex w-full flex-col gap-4 sm:max-w-md sm:flex-row sm:items-start"
                >
                  <div className="space-y-1.5">
                    <Input placeholder="Email" />
                    <p className="text-sm text-tertiary">
                      We care about your data in our{' '}
                      <FocusableLink
                        href="https://quotion.co/privacy-policy"
                        target="_blank"
                        className="underline"
                      >
                        privacy policy
                      </FocusableLink>
                      .
                    </p>
                  </div>
                  <Button size="lg" type="submit" className="w-full sm:w-auto">
                    Subscribe
                  </Button>
                </form>
              </div>
              <BackgroundBeams />
            </div>
          </section>
        </Safari>
      </BlurFade>
    </div>
  );
}
